import CookieNotice from 'components/pages/CookieNotice/CookieNotice';
import { buildPage } from 'utils/pageHelper';
export default buildPage(CookieNotice, {
  metaData: {
    title: 'Cookie Notice',
    description:
      'Qmee cookie notice which explains why we use them and how you can better control their use.',
  },
});
